<template>
	<el-container class="container largeScreen">
		<span class="lastClass">浙ICP备17006853号</span>
		<!--左侧-->
		<div class="aside_Left">
			<!--总能耗-->
			<div class="aside_top">
				<div class="lineBox">
					<span class="dot_left"></span>
					<div class="link_top"></div>
					<span class="dot_right"></span>
				</div>
				<div class="allNumber">
					<label>{{energyTotal}}</label>
					<div class="link_top3">
						<span class="dot_left3"></span>
						<span class="dot_right3"></span>
						<label class="allH">总能耗</label>
						<label class="kwh">kwh</label>
					</div>
				</div>
				<div class="backgroundClass1"></div>
				<div class="textTitle">
					<label class="number">{{dayFirst}}</label>
					<label class="time">当日累计</label>
				</div>
				<div class="processBox">
					<div class="processContent" :style="{width: dayWidth}"></div>
					<div class="linein">
						<div class="lineout">
						</div>
					</div>
				</div>
				<div class="textTitle">
					<label class="number">{{monthFirst}}</label>
					<label class="time">当月累计</label>
				</div>
				<div class="processBox">
					<div class="processContent" :style="{width: monthWidth}"></div>
					<div class="linein">
						<div class="lineout">
						</div>
					</div>
				</div>
			</div>
			<!--近7日能耗-->
			<div class="dayEnergy">
				<div class="lineBoxTop">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
					</div>
				</div>
				<div class="lineBoxBottom">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
						<div class="linein">
							<div class="lineout">
							</div>
						</div>
					</div>
				</div>
				<label class="titleLeft">近7日能耗</label>
				<label class="titleRight">kwh</label>
				<div id="paihangbang1" class="leftEcharts"></div>
			</div>
			<!--近半年能耗-->
			<div class="monthEnergy">
				<div class="lineBoxTop">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
					</div>
				</div>
				<div class="lineBoxBottom">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
						<div class="linein">
							<div class="lineout">
							</div>
						</div>
					</div>
				</div>
				<label class="titleLeft">近半年能耗</label>
				<label class="titleRight">kwh</label>
				<div id="paihangbang2" class="leftEcharts"></div>
			</div>
			<!--各项能耗排序-->
			<div class="allEnergySort">
				<div class="lineBoxTop">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
					</div>
				</div>
				<div class="lineBoxBottom">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
						<div class="linein">
							<div class="lineout">
							</div>
						</div>
					</div>
				</div>
				<label class="titleLeft">各项目能耗排序</label>
				<label class="titleRight">kwh</label>
				<div class="marquee_wrap">
					<ul class="marquee_list">
						<li v-for="item in lbList" class="marquee_li">
							<div class="tabLeft">{{item.project_name}}</div>
							<div class="tabright">{{item.val}}</div>
							<el-progress :text-inside="true" :stroke-width="6" :percentage="item.width" :format="format"></el-progress>
						</li>
					</ul>
				</div>
				<!--<div id="lip" class="allEcharts"></div>-->
			</div>
		</div>
		<!--中间-->
		<div class="aside_center">
			<!--上-->
			<el-header class="header">
				<!--网关数-->
				<div class="header_top">
					<div :class="gatewayShowL?'allGatewayBackground1':'allGatewayBackground2'" @click="gatewayLClick()">
						<div style="width:50%;text-align: center;display: inline-block;position: relative;">
							<div class="leftContainer">
								<i class="iconfont icon-arrow- firstL"></i>
								<i class="iconfont icon-arrow- secondL"></i>
								<i class="iconfont icon-arrow- thirdL"></i>
							</div>
							<div class="rightContainer">
								<i class="iconfont icon-arrow--copy thirdL"></i>
								<i class="iconfont icon-arrow--copy secondL"></i>
								<i class="iconfont icon-arrow--copy firstL" style="margin-left: -15px;"></i>
							</div>
							<div style="position: absolute;top:1px;left:30%;z-index: 10;">
								<span style="font-size: 28px;font-weight: bold;">{{gatewayTotal}}</span>
								<span class="gatewayText">总网关数</span>
							</div>
							<div class="allGatewayBoxWhite" :style="{width: deviceWidth1}">
								<div class="allGatewayContentWhite">
								</div>
							</div>
							<div class="allGatewayBoxOrange" :style="{width: deviceWidth2}">
								<div class="allGatewayContentOrange">
								</div>
							</div>
						</div>
					</div>
					<div :class="gatewayShowR?'allGatewayBackground2':'allGatewayBackground1'" @click="gatewayRClick()">
						<div style="width:50%;text-align: center;display: inline-block;position: relative;">
							<div class="leftContainer">
								<i class="iconfont icon-arrow- firstL"></i>
								<i class="iconfont icon-arrow- secondL"></i>
								<i class="iconfont icon-arrow- thirdL"></i>
							</div>
							<div class="rightContainer">
								<i class="iconfont icon-arrow--copy thirdL"></i>
								<i class="iconfont icon-arrow--copy secondL"></i>
								<i class="iconfont icon-arrow--copy firstL" style="margin-left: -15px;"></i>
							</div>
							<div style="position: absolute;top:1px;left:30%;z-index: 10;">
								<span style="font-size: 28px;font-weight: bold;">{{deviceTotal}}</span>
								<span class="gatewayText">总监测设备数</span>
							</div>
							<div class="allGatewayBoxWhite" :style="{width: deviceWidth3}">
								<div class="allGatewayContentWhite">
								</div>
							</div>
							<div class="allGatewayBoxOrange" :style="{width: deviceWidth4}">
								<div class="allGatewayContentOrange">
								</div>
							</div>
						</div>
					</div>
				</div>
				<!--网关在线人数-->
				<div class="header_bottom">
					<div class="rightLine">
						<span class="dot_left2"></span>
						<span class="dot_right2"></span>
					</div>
					<div class="header_content">
						<div style="display: flex;">
							<div style="flex:1;"></div>
							<div style="flex:2;">
								<p class="header_contentPL">{{deviceObj.gateway_on}}</p>
								<span class="header_contentSpan">网关在线数</span>
							</div>
							<div style="flex:2;">
								<p class="header_contentPR">{{deviceObj.gateway_off}}</p>
								<span class="header_contentSpan">网关离线数</span>
							</div>
							<div style="flex:1;"></div>
						</div>
						<div class="commonlyLine22"></div>
					</div>
					<div class="header_content">
						<div style="display: flex;">
							<div style="flex:1;"></div>
							<div style="flex:2;">
								<p class="header_contentPL">{{deviceObj.device_on}}</p>
								<span class="header_contentSpan">监测设备在线数</span>
							</div>
							<div style="flex:2;">
								<p class="header_contentPR">{{deviceObj.device_off}}</p>
								<span class="header_contentSpan">监测设备离线数</span>
							</div>
							<div style="flex:1;"></div>
						</div>
						<div class="commonlyLine33"></div>
					</div>
				</div>
			</el-header>
			<!--下-->
			<div class="main">
				<div id="map" style="width:100%;height:100%;position: relative;"></div>
				<!--<div class="lineClass3">
					<div class="plussign_Top">+</div>
					<div class="plussign_Bottom">+</div>
				</div>
				<div class="lineClass2">
					<div class="plussign_Top">+</div>
					<div class="plussign_Bottom">+</div>
				</div>
				<img src="../assets/earch.png" alt="" class="earchClass" />
				<div class="firstBox">
				</div>
				<div class="eightthBox">
					<div class="firstContent">
						<span>上海铁路局合肥车辆段</span>
						<div class="firsLine"></div>
						<div class="firsDot"></div>
						<img src="../assets/circle.png" alt="" class="firstImg" />
					</div>
				</div>
				<div class="seventhBox">
					<div class="firstContent">
						<span>佳好佳居饰商城</span>
						<div class="firsLine" v-if="commonShow"></div>
						<div class="firsDot" v-if="commonShow"></div>
						<div class="orangeLine" v-if="orangeShow"></div>
						<div class="redLine" v-if="redShow"></div>
						<div class="yellowLine" v-if="yellowShow"></div>
						<img src="../assets/orange.png" alt="" class="fourthImg" v-if="orangeShow" />
						<img src="../assets/red.png" alt="" class="fourthImg" v-if="redShow" />
						<img src="../assets/yellow.png" alt="" class="fourthImg" v-if="yellowShow" />
						<img src="../assets/circle.png" alt="" class="firstImg" v-if="commonShow" />
						<div class="secondLine"></div>
						<div class="thirdLine"></div>
						<div class="fourthLine"></div>
						<div class="fivethLine"></div>
						<div class="sixthLine"></div>
						<div class="seventhLine"></div>
						<div class="eightthLine"></div>
						<span class="secondText">杭州中豪建材市场</span>
						<span class="thirdText">浙江伏特宝科技有限公司</span>
						<span class="fourthText">嘉兴海盐科创园</span>
						<span class="fivethText">安德利集团有限公司</span>
						<span class="sixthText">义乌模具城</span>
						<span class="seventhText">义乌国际家居城</span>
					</div>
				</div>-->
			</div>
		</div>
		<!--右侧-->
		<div class="aside_Right">
			<i class="el-icon-close closeClass" @click="mapBack()"></i>
			<!--总项目数-->
			<div class="aside_top">
				<div class="lineBox">
					<span class="dot_left"></span>
					<div class="link_top"></div>
					<span class="dot_right"></span>
				</div>
				<div class="allNumber">
					<label>{{projectTotal}}</label>
					<div class="link_top3">
						<span class="dot_left3"></span>
						<span class="dot_right3"></span>
						<label class="allH">总项目数</label>
						<i class="el-icon-top kwh kwh2"></i>
					</div>
				</div>
				<div class="backgroundClass1"></div>
				<div class="textTitle">
					<label class="number">{{monthVal}}</label>
					<label class="time">本月新增</label>
				</div>
				<div class="processBox2">
					<div class="processContent2" :style="{width: monthCurrentWidth}"></div>
					<div class="linein">
						<div class="lineout">
						</div>
					</div>
				</div>
			</div>
			<!--项目总面积-->
			<div class="projectArea">
				<div class="lineBoxTop">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
					</div>
				</div>
				<div class="lineBoxBottom">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
						<div class="linein">
							<div class="lineout">
							</div>
						</div>
					</div>
				</div>
				<div class="backgroundClass2"></div>
				<label class="titleLeft">项目总面积</label>
				<div class="imgBox">
					<img src="../assets/background3.png" alt="" class="imgClass" />
				</div>
				<div id="chartPie" class="pie-wrap"></div>
			</div>
			<!--总报警数-->
			<div class="policeNumber">
				<div class="lineBoxTop">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
					</div>
				</div>
				<div class="lineBoxBottom">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
						<div class="linein">
							<div class="lineout">
							</div>
						</div>
					</div>
				</div>
				<div class="backgroundClass3"></div>
				<label class="titleLeft">总报警数 {{warnTotaoAll}}</label>
				<div class="typeBox">
					<div class="urgentBox">
						<div class="rightContainer2">
							<i class="iconfont icon-arrow--copy firstL1"></i>
							<i class="iconfont icon-arrow--copy secondL1"></i>
							<i class="iconfont icon-arrow--copy thirdL1"></i>
						</div>
						<div class="urgentLeft">
							<div class="urgentCircle">
								<i class="iconfont icon-shandian urgentDian"></i>
							</div>
							<div class="a"></div>
							<div class="b"></div>
							<div class="c"></div>
							<div class="d"></div>
						</div>
						<div style="flex:1"></div>
						<div class="urgentRight">
							<div class="urgentNumber">{{eventObj.h_num}}</div>
							<div class="urgentTitle">紧急警数</div>
							<div class="urgentLine"></div>
						</div>
					</div>
					<div class="urgentBox">
						<div class="rightContainer2">
							<i class="iconfont icon-arrow--copy firstL2"></i>
							<i class="iconfont icon-arrow--copy secondL2"></i>
							<i class="iconfont icon-arrow--copy thirdL2"></i>
						</div>
						<div class="middleLeft">
							<div class="urgentCircle">
								<i class="iconfont icon-shandian middleDian"></i>
							</div>
							<div class="a"></div>
							<div class="b"></div>
							<div class="c"></div>
							<div class="d"></div>
						</div>
						<div style="flex:1"></div>
						<div class="middleRight">
							<div class="urgentNumber">{{eventObj.m_num}}</div>
							<div class="urgentTitle">中级警数</div>
							<div class="middleLine"></div>
						</div>
					</div>
					<div class="urgentBox">
						<div class="rightContainer2">
							<i class="iconfont icon-arrow--copy firstL3"></i>
							<i class="iconfont icon-arrow--copy secondL3"></i>
							<i class="iconfont icon-arrow--copy thirdL3"></i>
						</div>
						<div class="commonlyLeft">
							<div class="urgentCircle">
								<i class="iconfont icon-shandian commonlyDian"></i>
							</div>
							<div class="a"></div>
							<div class="b"></div>
							<div class="c"></div>
							<div class="d"></div>
						</div>
						<div style="flex:1"></div>
						<div class="commonlyRight">
							<div class="urgentNumber">{{eventObj.l_num}}</div>
							<div class="urgentTitle">一般警数</div>
							<div class="commonlyLine"></div>
						</div>
					</div>
				</div>
			</div>
			<!--项目报警比对-->
			<div class="projectPolice">
				<div class="lineBoxTop">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
					</div>
				</div>
				<div class="lineBoxBottom">
					<div class="lineContent">
						<span class="dot_left"></span>
						<div class="link_top"></div>
						<span class="dot_right"></span>
						<div class="linein">
							<div class="lineout">
							</div>
						</div>
					</div>
				</div>
				<div class="backgroundClass4"></div>
				<label class="titleLeft">项目报警对比</label>
				<div class="ulbox">
					<div class="ul">
						<div class="processsAmClass"></div>
						<div>
							<label class="titleLeft2">{{currentWarnLObj.name}}</label>
							<label class="titleRight2">总报警{{warnTotal}}</label>
						</div>
						<div class="processClass">
							<div class="processClassline" v-if="!warnTotal"></div>
							<div class="urgentProcess" :style="{width: processWidth1}"></div>
							<div class="middleProcess" :style="{width: processWidth2}"></div>
							<div class="commonlyProcess" :style="{width: processWidth3}"></div>
						</div>
						<div class="processText">
							<span class="urgentText" v-if="currentWarnLObj.h_num">紧急报警{{currentWarnLObj.h_num}}</span>
							<span class="middleText" v-if="currentWarnLObj.m_num">中级报警{{currentWarnLObj.m_num}}</span>
							<span class="commonlyText" v-if="currentWarnLObj.l_num">一般报警{{currentWarnLObj.l_num}}</span>
						</div>
					</div>
				</div>

			</div>
		</div>
	</el-container>
</template>

<script>
	import headers from '../../static/js/headers.js'
	import md5 from '../../static/js/md5.js'
	import qs from 'qs'
	import axios from 'axios'
	import echarts from 'echarts'
	import { mapGetters, mapActions } from 'Vuex';
	export default {
		mounted() {
			this.b_id = window.sessionStorage.getItem('b_id')
			this.getTotalEnergyByBFun(); //总能耗统计列表
			this.getDayEnergyByBFun(); //近七天
			this.getMonthEnergyByBFun(); //近半年
			this.getProjectEnergy(); //各项目能耗统计列表
			this.getDevice(); //设备信息统计列表
			this.getcountProjectFun(); //项目总数、当月新增
			this.getByBList(); //项目列表、累计总面积
			this.getEvent(); //报警统计列表
			this.mapAllFun()
			document.querySelectorAll('.urgentCircle')[0].style.height = document.querySelectorAll('.urgentCircle')[0].offsetWidth + 'px'
			document.querySelectorAll('.urgentCircle')[1].style.height = document.querySelectorAll('.urgentCircle')[1].offsetWidth + 'px'
			document.querySelectorAll('.urgentCircle')[2].style.height = document.querySelectorAll('.urgentCircle')[2].offsetWidth + 'px'
			/*echarts自适应*/
			let myChart1 = require('echarts').init(document.getElementById('paihangbang1'))
			let myChart2 = require('echarts').init(document.getElementById('paihangbang2'))
			let myChart3 = require('echarts').init(document.getElementById('chartPie'))

			window.addEventListener('resize', () => {
				document.querySelectorAll('.urgentCircle')[0].style.height = document.querySelectorAll('.urgentCircle')[0].offsetWidth + 'px'
				document.querySelectorAll('.urgentCircle')[1].style.height = document.querySelectorAll('.urgentCircle')[1].offsetWidth + 'px'
				document.querySelectorAll('.urgentCircle')[2].style.height = document.querySelectorAll('.urgentCircle')[2].offsetWidth + 'px'
				myChart1.resize();
				myChart2.resize();
				myChart3.resize();
			}, false);
		},
		computed: {
			...mapGetters(['http'])
		},
		data() {
			return {
				b_id: '', //b_id
				/*能耗统计*/
				energyTotal: 0, //总能耗
				energyDayList: [], //能耗近7日列表
				day_List: [],
				maxDay: 0,
				dayFirst: 0,
				dayWidth: 0,
				energyDayValueList: [],
				energyMonthList: [], //能耗近半年列表
				month_List: [],
				monthFirst: 0,
				maxMonth: 0,
				monthWidth: 0,
				/*各项目能耗统计todo*/
				energyNumbeTotal: 0,
				energyNumbeTotalList: [],
				energyNumbeTitleList: [],
				lbList: [],
				/*设备信息统计*/
				deviceObj: {}, //设备信息统计列表
				gatewayTotal: 0,
				deviceTotal: 0,
				deviceWidth1: '',
				deviceWidth2: '',
				deviceWidth3: '',
				deviceWidth4: '',
				gatewayShowL: true,
				gatewayShowR: true,
				/*项目总数、当月新增*/
				projectTotal: 0, //项目总数
				monthVal: 0, //本月新增
				monthCurrentWidth: 0,
				/*项目列表、累计总面积*/
				projectList: [], //所有项目列表
				areaTotal: 0, //总面积
				/*地图todo*/
				commonShow: false,
				redShow: false,
				orangeShow: false,
				yellowShow: false,
				/*报警统计*/
				eventObj: {}, //报警列表
				warnTotaoAll: 0,
				/*各项目报警统计todo*/
				countProjectList: [], //总列表
				currentWarnLObj: {},
				processWidth1: 0, //宽度
				processWidth2: 0, //宽度
				processWidth3: 0, //宽度
				warnTotal: 0,
				/*百度地图*/
				map: null,
				localLongitude: 102.6, //本地经度
				localLatitude: 40.4, //本地纬度
				//				localLatitude: 35.4, //本地纬度
				mapLev: 5, //地图等级
			}
		},
		created() {},
		methods: {
			//各项目报警统计
			getCountProject() {
				var params = {
					b_id: this.b_id
				}
				//console.log(params)
				let config = headers.headers('countProjectByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event_device/countProjectByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.countProjectList = res.data
						this.countProjectList.forEach(item => {
							if(item.id == this.lbList[0].project_id) {
								this.currentWarnLObj = item
							} else {
								this.currentWarnLObj = {
									name: this.lbList[0].name
								}
							}
						})
						this.warnTotal = 0;
						if(this.currentWarnLObj.id) {
							this.warnTotal = Number(this.currentWarnLObj.h_num) + Number(this.currentWarnLObj.m_num) + Number(this.currentWarnLObj.l_num)
							this.processWidth1 = this.currentWarnLObj.h_num / this.warnTotal * 100 + '%'
							this.processWidth2 = this.currentWarnLObj.m_num / this.warnTotal * 100 + '%'
							this.processWidth3 = this.currentWarnLObj.l_num / this.warnTotal * 100 + '%'
						} else {
							this.warnTotal = 0;
							this.processWidth1 = 0
							this.processWidth2 = 0
							this.processWidth3 = 0
						}
						//绘点
						this.countProjectList.forEach(item => {
							this.projectList.forEach(item_p => {
								if(item.id == this.lbList[0].project_id && item_p.id == item.id) {
									item_p.h_num = item.h_num
									item_p.m_num = item.m_num
									item_p.l_num = item.l_num
								}
							})
						})
						this.mapHDFun()
					} else {
						this.countProjectList = []
						this.currentWarnLObj = {
							name: this.lbList[0].name
						}
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//轮播
			scrollAnimate() {
				setTimeout(() => {
					this.projectList = JSON.parse(window.localStorage.projectListS);

					this.lbList.push(this.lbList[0]);
					this.lbList.shift();
					this.countProjectList.forEach(item => {
						if(item.id == this.lbList[0].project_id) {
							this.currentWarnLObj = item
						} else {
							this.currentWarnLObj = {
								name: this.lbList[0].name
							}
						}
					})
					this.warnTotal = 0;
					if(this.currentWarnLObj.id) {
						this.warnTotal = Number(this.currentWarnLObj.h_num) + Number(this.currentWarnLObj.m_num) + Number(this.currentWarnLObj.l_num)
						this.processWidth1 = this.currentWarnLObj.h_num / this.warnTotal * 100 + '%'
						this.processWidth2 = this.currentWarnLObj.m_num / this.warnTotal * 100 + '%'
						this.processWidth3 = this.currentWarnLObj.l_num / this.warnTotal * 100 + '%'
					} else {
						this.warnTotal = 0;
						this.processWidth1 = 0
						this.processWidth2 = 0
						this.processWidth3 = 0
					}
					var allOverlay = this.map.getOverlays();
					for(var i = 0; i < allOverlay.length; i++) {
						this.map.removeOverlay(allOverlay[i]);
					}
					//绘点
					this.countProjectList.forEach(item => {
						this.projectList.forEach(item_p => {
							if(item.id == this.lbList[0].project_id && item_p.id == item.id) {
								item_p.h_num = item.h_num
								item_p.m_num = item.m_num
								item_p.l_num = item.l_num
							}
						})
					})
					this.mapHDFun()
				}, 1000);
			},
			//总能耗
			getTotalEnergyByBFun() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getTotalEnergyByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/prestatistic/getTotalEnergyByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.energyTotal = Math.round(res.data)
					} else {
						this.energyTotal = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//7天
			getDayEnergyByBFun() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getDayEnergyByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/prestatistic/getDayEnergyByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res, '近七天')
					if(res.data.length > 0) {
						this.day_List = []
						this.dayFirst = 0
						this.maxDay = 0
						this.dayWidth = 0
						this.energyDayList = []
						res.data.forEach(item => {
							this.day_List.push(Number(item.v5))
							item.trade_num = Math.round(item.v5),
								item.goods_name = String(item.data_time).slice(-2) + '日'
						})
						this.energyDayList = res.data
						var maxDay = this.day_List[0];
						this.dayFirst = Math.round(this.day_List[this.day_List.length - 1]);
						for(var i = 1; i < this.day_List.length; i++) {
							if(this.day_List[i] > maxDay) {
								maxDay = this.day_List[i];
							}
						}
						this.maxDay = maxDay
						this.dayWidth = this.dayFirst / this.maxDay * 100 + '%'
						this.drawLine2();
					} else {
						this.day_List = []
						this.dayFirst = 0
						this.maxDay = 0
						this.dayWidth = 0
						this.energyDayList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//半年
			getMonthEnergyByBFun() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getMonthEnergyByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/prestatistic/getMonthEnergyByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res, '近半年')
					if(res.data.length > 0) {
						this.month_List = []
						this.monthFirst = 0
						this.maxMonth = 0
						this.monthWidth = 0
						this.energyMonthList = []
						res.data.forEach(item => {
							this.month_List.push(Number(item.v5))
							item.trade_num = Math.round(item.v5),
								item.goods_name = String(item.data_time).slice(-2) + '月'
						})
						this.energyMonthList = res.data
						var maxMonth = this.month_List[0];
						this.monthFirst = Math.round(this.month_List[this.month_List.length - 1]);
						for(var i = 1; i < this.month_List.length; i++) {
							if(this.month_List[i] > maxMonth) {
								maxMonth = this.month_List[i];
							}
						}
						this.maxMonth = maxMonth
						this.monthWidth = this.monthFirst / this.maxMonth * 100 + '%'
						this.drawLine1();
					} else {
						this.month_List = []
						this.monthFirst = 0
						this.maxMonth = 0
						this.monthWidth = 0
						this.energyMonthList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//各项目能耗统计列表
			getProjectEnergy() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getProjectEnergyByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/prestatistic/getProjectEnergyByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						var num = 0
						res.data.forEach((item, index) => {
							item.project_id = item.id
							item.project_name = item.name
							item.val = item.v5
						})
						res.data.forEach((item, index) => {
							item.name = item.project_name
							item.project_name = '0' + (index + 1) + '-' + item.project_name
							num += Number(item.val)
						})
						this.lbList = res.data
						this.lbList.forEach((item, index) => {
							item.width = item.val / num * 100
							//item.width = parseInt(item.val / num * 100)//取整
						})
						this.getCountProject(); //各项目报警统计
						setInterval(this.scrollAnimate, 4000);
						res.data.forEach((item, index) => {
							this.energyNumbeTotalList.push(Math.round(item.val))
							this.energyNumbeTitleList.push('0' + (index + 1) + '-' + item.project_name)
						})
						this.energyNumbeTotalList = this.energyNumbeTotalList.reverse()
						var maxNumber = this.energyNumbeTotalList[0];
						for(var i = 1; i < this.energyNumbeTotalList.length; i++) {
							if(this.energyNumbeTotalList[i] > maxNumber) {
								maxNumber = this.energyNumbeTotalList[i];
							}
						}
						this.energyNumbeTotal = maxNumber + maxNumber * 0.05
						//this.initEchartsFh();//已弃用
					} else {
						this.energyNumbeTotal = 0
						this.energyNumbeTotalList = []
						this.energyNumbeTitleList = []
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//设备信息统计列表
			getDevice() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('countDevice')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/screenShow/countDevice', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.deviceObj = res.data
						this.gatewayTotal = res.data.gateway_on + res.data.gateway_off
						this.deviceTotal = res.data.device_on + res.data.device_off
						this.deviceWidth1 = res.data.gateway_on / this.gatewayTotal * 100 + '%'
						this.deviceWidth2 = res.data.gateway_off / this.gatewayTotal * 100 + '%'
						this.deviceWidth3 = res.data.device_on / this.deviceTotal * 100 + '%'
						this.deviceWidth4 = res.data.device_off / this.deviceTotal * 100 + '%'
					} else {
						this.deviceObj = {}
						this.deviceWidth1 = 0
						this.deviceWidth2 = 0
						this.deviceWidth3 = 0
						this.deviceWidth4 = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//项目总数、当月新增
			getcountProjectFun() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('countProject')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/screenShow/countProject', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.projectTotal = res.data.total
						this.monthVal = res.data.month
						this.monthCurrentWidth = this.monthVal / this.projectTotal * 100 + '%'
					} else {
						this.projectTotal = 0
						this.monthVal = 0
						this.monthCurrentWidth = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//项目列表、累计总面积
			getByBList() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/project/getByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data.length > 0) {
						this.projectList = res.data
						window.localStorage.projectListS = JSON.stringify(this.projectList);
						window.sessionStorage.setItem('projectListS', this.mapLev)
						this.projectList.forEach(item => {
							if(item.area) {
								this.areaTotal += Number(item.area)
							}
						})
						this.areaTotal = this.areaTotal + '/km²'
						this.$nextTick(() => {
							this.drawPieChart();
						});
					} else {
						this.projectList = []
						this.areaTotal = 0
					}

				}).catch(err => {
					console.log(err)
				})
			},
			/*绘点fun*/
			mapHDFun() {
				this.projectList.forEach(item => {
					item.point = item.longitude + '|' + item.latitude
				})
				var point = []; //定义数组标注经纬信息
				var marker = []; //定义数组点对象信息
				/*渲染多个地图绘点*/
				if(document.createElement('canvas').getContext) { // 判断当前浏览器是否支持绘制海量点
					for(var i = 0; i < this.projectList.length; i++) { //遍历
						var infoA = this.projectList[i].point.split("|")[0]; //分割|
						var infoB = this.projectList[i].point.split("|")[1];
						var icon;
						//						if(this.projectList[i].l_num && this.projectList[i].l_num > 0) {
						//							icon = new BMap.Icon(require('../assets/yellow6.gif'), new BMap.Size(50, 50));
						//						} else {
						//							icon = new BMap.Icon(require('../assets/circle3.gif'), new BMap.Size(50, 50));
						//						}
						//						if(this.projectList[i].m_num && this.projectList[i].m_num > 0) {
						//							icon = new BMap.Icon(require('../assets/orange6.gif'), new BMap.Size(50, 50));
						//						} else {
						//							icon = new BMap.Icon(require('../assets/circle3.gif'), new BMap.Size(50, 50));
						//						}
						//						if(this.projectList[i].h_num && this.projectList[i].h_num > 0) {
						//							icon = new BMap.Icon(require('../assets/red6.gif'), new BMap.Size(50, 50));
						//						} else {
						//							icon = new BMap.Icon(require('../assets/circle3.gif'), new BMap.Size(50, 50));
						//						}

						if(this.projectList[i].h_num && this.projectList[i].h_num > 0) {
							icon = new BMap.Icon(require('../assets/red6.gif'), new BMap.Size(50, 50));
						} else if(!this.projectList[i].h_num && this.projectList[i].m_num && this.projectList[i].m_num > 0) {
							icon = new BMap.Icon(require('../assets/orange6.gif'), new BMap.Size(50, 50));
						} else if(!this.projectList[i].h_num && !this.projectList[i].m_num && this.projectList[i].m_num && this.projectList[i].m_num > 0) {
							icon = new BMap.Icon(require('../assets/yellow6.gif'), new BMap.Size(50, 50));
						} else {
							icon = new BMap.Icon(require('../assets/circle4.gif'), new BMap.Size(50, 50));
						}

						point[i] = new window.BMap.Point(infoA, infoB);
						marker[i] = new window.BMap.Marker(point[i], {
							icon: icon
						});
						this.map.addOverlay(marker[i]);
						//						marker[i].setAnimation(BMAP_ANIMATION_BOUNCE);//坠落动画
						var _this = this
						marker[i].addEventListener('onmouseover', function(e) {
							var p = e.target;
							console.log(p.getPosition().lng ,p.getPosition().lat)
							_this.projectList.forEach(item => {
								if(item.longitude == p.getPosition().lng && item.latitude == p.getPosition().lat) {
									_this.currentWarnObj = item
									var opts = {
										title: "<div class='projectClass' style='font-size:12px;color:#fff;text-align:center;' id='ceshi'>" + _this.currentWarnObj.c_name + "</div>",
										offset: new BMap.Size(-26, 110),
									};
									var infoWindow = new BMap.InfoWindow('<div id="ceshi2" style="font-size:12px;color:#fff;text-align:center;">' + _this.currentWarnObj.name + '</div>', opts); // 创建信息
									this.openInfoWindow(infoWindow);
								}
							})
						});
						marker[i].addEventListener('onmouseout', function(e) {
							_this.map.closeInfoWindow()
						});
					}
				} else {
					alert('请在chrome、safari、IE8+以上浏览器查看本示例');
				}
			},
			//报警统计列表(总)
			getEvent() {
				var params = {
					b_id: this.b_id
				}
				let config = headers.headers('getByB')
				var pass_token = config.pass_token
				var timestamp = config.timestamp
				axios.get(this.http + '/zkep2/event_device/getByB', {
					params,
					headers: {
						'pass-token': pass_token,
						'time': timestamp
					}
				}).then(res => {
					//console.log(res)
					if(res.data) {
						this.eventObj = res.data
						this.warnTotaoAll += res.data.h_num + res.data.m_num + res.data.l_num
					} else {
						this.eventObj = {}
						this.warnTotaoAll = 0
					}
				}).catch(err => {
					console.log(err)
				})
			},
			//网关的点击
			gatewayLClick() {
				this.gatewayShowL = true
				this.gatewayShowR = true
			},
			gatewayRClick() {
				this.gatewayShowL = false
				this.gatewayShowR = false
			},
			/*4*/
			drawPieChart() {
				var echarts = require('echarts');
				this.chartPie = echarts.init(
					document.getElementById("chartPie"),
					"macarons"
				);
				this.chartPie.clear(); //初始化
				this.chartPie.setOption({
					//显示在上面的文字
					tooltip: {
						show: false,
						trigger: "item",
						formatter: "{b}: <br/>{c}({d}%)",
					},
					legend: {
						data: ["直接访问"],
						right: 400,
						orient: "vertical",
					},
					series: [{
						name: "",
						type: "pie",
						radius: ["34%", "66%"],
						center: ["50%", "50%"],
						silent: false,
						clockwise: false, //逆时针
						hoverAnimation: false, //去掉鼠标经过放大
						z: 0,
						zlevel: 10,
						labelLine: {
							show: false
						},
						label: { //  饼图图形上的文本标签
							normal: { // normal 是图形在默认状态下的样式
								show: true,
								position: 'center',
								fontWeight: 'bold',
								formatter: '{b|{b}}', // {b}:数据名； {c}：数据值； {d}：百分比，可以自定义显示内容，
								rich: {
									b: {
										color: '#62F3FF',
										padding: [0, 10],
										fontSize: 10
									},
								}
							}
						},
						data: [{
								value: 2,
								itemStyle: {
									color: "#275262",
									borderColor: "#275262",
								}
							}, {
								value: 9,
								name: this.areaTotal,
								itemStyle: {
									normal: {
										borderColor: {
											colorStops: [{
													offset: 0,
													color: "#fff" // 0% 处的颜色
												},
												{
													offset: 0.5,
													color: "#275262" // 0% 处的颜色
												},
												{
													offset: 1,
													color: "#275262" // 100% 处的颜色
												}
											]
										},
										color: {
											// 完成的圆环的颜色
											colorStops: [{
													offset: 0,
													color: "#fff" // 0% 处的颜色
												},
												{
													offset: 0.5,
													color: "#275262" // 0% 处的颜色
												},
												{
													offset: 1,
													color: "#275262" // 100% 处的颜色
												}
											]
										},

										label: {
											show: false
										}
									}
								}
							},

						]
					}]
				});
			},
			/*3*/
			initEchartsFh() {
				var echarts = require('echarts');
				var myChart = echarts.init(document.getElementById('lip'));
				var myColor = ['#81E7ED'] //内柱状图颜色
				var dataLine = this.energyNumbeTotalList
				var barBorderRadius = []
				var barGapData = []
				this.energyNumbeTotalList.forEach(item => {
					barBorderRadius.push(0)
					barGapData.push(this.energyNumbeTotal)
				})
				let positionLeft = 0.4,
					max = 100 + 2 * positionLeft
				var option = {
					grid: {
						x: 0, //左留白
						y: 10, //上留白
						x2: 35, //右留白
						y2: 6 //下留白
					},
					xAxis: [{
						max: max,
						show: false
					}],
					yAxis: [{
							show: true, //todo------
							axisTick: 'none',
							axisLine: 'none',
							offset: 0,
							axisLabel: {
								textStyle: {
									color: '#fff',
									fontSize: '12',
									lineHeight: 20,
								},
								// 调整左侧文字的3个属性，缺一不可
								verticalAlign: 'bottom',
								align: 'left',
								//调整文字上右下左
								padding: [0, 0, 0, 10],
								/*处理文字过长的问题*/
								formatter: function(value) {
									let valueText = ''
									if(value.length > 12) {
										valueText = value.substring(0, 12) + '...'
									} else {
										valueText = value
									}
									return valueText
								}
							},
							data: this.energyNumbeTitleList.reverse()
						}, {
							axisTick: 'none',
							axisLine: 'none',
							show: false,
							axisLabel: {
								textStyle: {
									color: '#fff',
									fontSize: '12'
								},
								// 调整右侧数值文字的3个属性，缺一不可
								padding: [0, 0, 0, 0],
								formatter: '{value}%'
							},
							data: [1, 1, ]
						}, {

							axisLine: {
								lineStyle: {
									color: 'rgba(0,0,0,0)' //y轴线颜色
								}
							},
							data: []
						},
						{ //设置柱状图右边参数 
							show: false, //todo
							inverse: true,
							data: dataLine,
							axisLine: {
								show: false
							},
							splitLine: {
								show: false
							},
							axisTick: {
								show: false
							},
						}
					],
					series: [{
							name: '条',
							type: 'bar',
							stack: 'b',
							yAxisIndex: 0,
							data: dataLine,
							label: {
								normal: {
									show: false, //todo-----------
									align: 'left',
									position: [162, -14],
									//									distance: 10,
									formatter: function(param) {
										return param.value
									},
									textStyle: {
										color: '#fff',
										fontSize: '12'
									}
								}
							},
							barWidth: 6,
							itemStyle: {
								normal: {
									color: '#4493A0',
									barBorderRadius: [0, 0, ],
								}
							},
							z: 2
						}, { //背景灰框
							name: '白框',
							type: 'bar',
							yAxisIndex: 1,
							barGap: '-100%', //设置-100% 则表示灰色柱状图与红色柱状图重合
							data: barGapData,
							barWidth: 6,
							itemStyle: {
								normal: {
									color: 'rgba(43,61,65,1)',
									barBorderRadius: barBorderRadius,
								},
							},
							z: 1 // 设置维度越高这表示覆盖低的
						},
						{
							name: '外框',
							type: 'bar',
							yAxisIndex: 2,
							barGap: '-100%',
							data: barGapData,
							barWidth: 6,
							label: {
								normal: {
									align: 'left',
									show: true, //todo--------
									position: ['81%', '-190%'],
									left: 100,
									margin: 0,
									distance: 0,
									color: '#fff',
									formatter: function(data) {
										return dataLine[data.dataIndex];
									},
								}
							},
							itemStyle: {
								normal: {
									color: '#DDDDDD',
									barBorderRadius: barBorderRadius,
								}
							},
							z: 0
						}
					],
				}
				myChart.setOption(option);
			},
			/*2*/
			drawLine1() {
				var weatherIcons = {
					first: "../../../static/img/first.png",
					second: "../../../static/img/second.png",
					third: ".../../../static/img/third.png"
				};
				var paihangOption = {
					title: {},
					tooltip: {
						show: false, //显示提示框//todo
						trigger: "axis"
					},
					legend: {
						data: []
					},
					grid: {
						x: '14.5%', //左留白
						y: 10, //上留白
						x2: '50%', //右留白
						y2: 30 //下留白
					},
					calculable: true,
					dataset: {
						dimensions: ["goods_name", "trade_num"],
						source: this.energyMonthList
					},
					xAxis: [{
						splitLine: {
							show: false
						},
						type: "value",
						axisLine: {
							show: false,
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
								width: 1
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							margin: 100,
							textStyle: {
								align: "left",
								color: "#00FFFF", //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						}
					}],
					yAxis: [{
						type: "category",
						offset: -4, //todo
						inverse: true,
						axisLine: {
							lineStyle: {
								color: "rgba(255, 255, 255, 0)", //todo 
								width: 1
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: function(value, index) {
									return index < 0 ? "#FDAD00" : "#fff"; //todo
								},
								//更改坐标轴文字颜色
								fontSize: 12 //更改坐标轴文字大小
							},
							formatter: function(value, index) {
								return value; //todo
							},
							rich: {
								value: {
									color: "#fff",
									fontSize: 12
								},
								first: {
									color: "FDAD00",
									backgroundColor: {
										image: weatherIcons.first
									}
								},
								second: {
									color: "FDAD00",
									backgroundColor: {
										image: weatherIcons.second
									}
								},
								third: {
									color: "FDAD00",
									backgroundColor: {
										image: weatherIcons.third
									}
								}
							}
						}
					}],
					series: [{
						type: "bar",
						itemStyle: {
							normal: {
								//每根柱子颜色设置
								color: function(params) {
									var _this = this;
									let colorList = [
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041']
									];
									var index = params.dataIndex;
									return {
										colorStops: [{
												offset: 0.8, //颜色的开始位置
												color: colorList[index][0] // 0% 处的颜色
											},
											{
												offset: 0, //颜色的结束位置
												color: colorList[index][1] // 100% 处的颜色
											}
										]
									};
								}
							}
						}, //柱状图上显示数据
						label: {
							show: "true",
							align: 'right',
							position: [155, 0], //todo
							color: "#FFF",
							fontSize: "12",
						}
					}]
				};
				var echarts = require('echarts');
				let myChart2 = echarts.init(document.getElementById("paihangbang2"));
				myChart2.clear(); //初始化
				myChart2.setOption(paihangOption);
			},
			/*1*/
			drawLine2() {
				//				console.log(this.energyDayList)
				var weatherIcons = {
					first: "../../../static/img/first.png",
					second: "../../../static/img/second.png",
					third: ".../../../static/img/third.png"
				};
				var paihangOption = {
					title: {},
					tooltip: {
						show: false, //显示提示框//todo
						trigger: "axis"
					},
					legend: {
						data: []
					},
					grid: {
						x: '14.5%', //左留白
						y: 10, //上留白
						x2: '42%', //右留白
						y2: 30 //下留白
					},
					calculable: true,
					dataset: {
						dimensions: ["goods_name", "trade_num"],
						source: this.energyDayList
					},
					xAxis: [{
						splitLine: {
							show: false
						},
						type: "value",
						axisLine: {
							show: false,
							lineStyle: {
								color: "rgba(255, 255, 255, 0.3)",
								width: 1
							}
						},
						axisTick: {
							show: false
						},
						axisLabel: {
							show: true,
							margin: 100,
							textStyle: {
								align: "left",
								color: "#00FFFF", //更改坐标轴文字颜色
								fontSize: 10 //更改坐标轴文字大小
							}
						}
					}],
					yAxis: [{
						type: "category",
						offset: -4, //todo
						inverse: true,
						axisLine: {
							lineStyle: {
								color: "rgba(255, 255, 255, 0)", //todo 
								width: 1
							}
						},
						axisLabel: {
							show: true,
							textStyle: {
								color: function(value, index) {
									return index < 0 ? "#FDAD00" : "#fff"; //todo
								},
								//更改坐标轴文字颜色
								fontSize: 12 //更改坐标轴文字大小
							},
							formatter: function(value, index) {
								return value; //todo
							},
							rich: {
								value: {
									color: "#fff",
									fontSize: 12
								},
								first: {
									color: "FDAD00",
									backgroundColor: {
										image: weatherIcons.first
									}
								},
								second: {
									color: "FDAD00",
									backgroundColor: {
										image: weatherIcons.second
									}
								},
								third: {
									color: "FDAD00",
									backgroundColor: {
										image: weatherIcons.third
									}
								}
							}
						}
					}],
					series: [{
						type: "bar",
						itemStyle: {
							normal: {
								//每根柱子颜色设置
								color: function(params) {
									var _this = this;
									let colorList = [
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
										["#62F3FF", '#2D4041'],
									];
									var index = params.dataIndex;
									return {
										colorStops: [{
												offset: 0.8, //颜色的开始位置
												color: colorList[index][0] // 0% 处的颜色
											},
											{
												offset: 0, //颜色的结束位置
												color: colorList[index][1] // 100% 处的颜色
											}
										]
									};
								}
							}
						}, //柱状图上显示数据
						label: {
							align: 'right',
							show: "true",
							position: [164, 0], //todo
							color: "#FFF",
							fontSize: "12"
						}
					}]
				};
				var echarts = require('echarts');
				let myChart = echarts.init(document.getElementById("paihangbang1"));
				myChart.clear(); //初始化
				myChart.setOption(paihangOption);
			},
			mapBack() {
				this.$router.go(-1); //返回上一层
			},
			//隐藏文字
			format(percentage) {
				return ''
			},
			/*地图初始化*/
			mapAllFun() {
				/*初始化地图*/

				this.map = new BMap.Map("map"); // 创建Map实例
				this.map.centerAndZoom(new BMap.Point(this.localLongitude, this.localLatitude), 7); // 初始化地图,设置中心点坐标和地图级别
				//				this.map.enableScrollWheelZoom(true);
				this.map.setZoom(5);
				//添加地图类型控件
				this.map.addControl(new BMap.MapTypeControl({
					mapTypes: [
						BMAP_NORMAL_MAP, //地图模式
					]
				}));
				this.map.setCurrentCity("杭州");
				//				this.map.setMapStyleV2({
				//					styleId:'396bf7ded5259a4198730fc9ec45d522'
				//				})
				this.map.setMapStyleV2({
					styleId: 'e7f6ab8e0e975a831bb52db0f96d0fd3'
				})

				//styleJson地图样式
				//				this.map.setMapStyle({
				//					styleJson: [{
				//						"featureType": "land",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"color": "#111"
				//						}
				//					}, {
				//						"featureType": "water",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"color": "#1A1A1A"
				//						}
				//					}, {
				//						"featureType": "green",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							//							"color": "#0e1b30ff"
				//						}
				//					}, {
				//						"featureType": "building",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "building",
				//						"elementType": "geometry.topfill",
				//						"stylers": {
				//							"color": "#1A1A1A"
				//						}
				//					}, {
				//						"featureType": "building",
				//						"elementType": "geometry.sidefill",
				//						"stylers": {
				//							//							"color": "#143e56ff"
				//						}
				//					}, {
				//						"featureType": "building",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							//							"color": "#dadada00"
				//						}
				//					}, {
				//						"featureType": "subwaystation",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"color": "#1A1A1A"
				//						}
				//					}, {
				//						"featureType": "education",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "medical",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "scenicspots",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"weight": 4
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							//							"color": "#fed66900"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "arterial",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"weight": 2
				//						}
				//					}, {
				//						"featureType": "arterial",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "arterial",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							//							"color": "#ffeebb00"
				//						}
				//					}, {
				//						"featureType": "arterial",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "arterial",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "arterial",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "local",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on",
				//							"weight": 1
				//						}
				//					}, {
				//						"featureType": "local",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "local",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "local",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "local",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				////							"color": "#979c9aff"
				//						}
				//					}, {
				//						"featureType": "local",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#fff"
				//						}
				//					}, {
				//						"featureType": "railway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "subway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"weight": 1
				//						}
				//					}, {
				//						"featureType": "subway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#d8d8d8ff"
				//						}
				//					}, {
				//						"featureType": "subway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "subway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "subway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#979c9aff"
				//						}
				//					}, {
				//						"featureType": "subway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffffffff"
				//						}
				//					}, {
				//						"featureType": "continent",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "continent",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "continent",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "continent",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "city",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "city",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "city",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "city",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "town",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "town",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "town",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#454d50ff"
				//						}
				//					}, {
				//						"featureType": "town",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffffffff"
				//						}
				//					}, {
				//						"featureType": "road",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "poilabel",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "districtlabel",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "road",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "road",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "road",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "district",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "poilabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "poilabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "poilabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "manmade",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "districtlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffffffff"
				//						}
				//					}, {
				//						"featureType": "entertainment",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "shopping",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "6"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "7"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "8"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "9"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "10"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "6"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "7"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "8"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "9"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "10"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "6"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "7"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "8"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "9"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,10",
				//							"level": "10"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "6"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "7"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "8"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"stylers": {
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "9"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "6"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "7"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "8"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "9"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "6"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "7"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "8"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off",
				//							"curZoomRegionId": "0",
				//							"curZoomRegion": "6,9",
				//							"level": "9"
				//						}
				//					}, {
				//						"featureType": "subwaylabel",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "subwaylabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "tertiarywaysign",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "tertiarywaysign",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "provincialwaysign",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "provincialwaysign",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "nationalwaysign",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "nationalwaysign",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "highwaysign",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "highwaysign",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "village",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "district",
				//						"elementType": "labels.text",
				//						"stylers": {
				//							"fontsize": 20
				//						}
				//					}, {
				//						"featureType": "district",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "district",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "country",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "country",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "water",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "water",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "tertiaryway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "tertiaryway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffffff10"
				//						}
				//					}, {
				//						"featureType": "provincialway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "provincialway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "highway",
				//						"elementType": "labels.text",
				//						"stylers": {
				//							"fontsize": 20
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "nationalway",
				//						"elementType": "labels.text",
				//						"stylers": {
				//							"fontsize": 20
				//						}
				//					}, {
				//						"featureType": "provincialway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "provincialway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "provincialway",
				//						"elementType": "labels.text",
				//						"stylers": {
				//							"fontsize": 20
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels.text",
				//						"stylers": {
				//							"fontsize": 20
				//						}
				//					}, {
				//						"featureType": "cityhighway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "estate",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "tertiaryway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "tertiaryway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "fourlevelway",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "fourlevelway",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "scenicspotsway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "scenicspotsway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "universityway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "universityway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "vacationway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "vacationway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "fourlevelway",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "fourlevelway",
				//						"elementType": "geometry.fill",
				//						"stylers": {
				//							"color": "#1B1B1B"
				//						}
				//					}, {
				//						"featureType": "fourlevelway",
				//						"elementType": "geometry.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "transportationlabel",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "transportationlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "transportationlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "transportationlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "educationlabel",
				//						"elementType": "labels",
				//						"stylers": {
				//							"visibility": "on"
				//						}
				//					}, {
				//						"featureType": "educationlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "educationlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "educationlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "transportation",
				//						"elementType": "geometry",
				//						"stylers": {
				//							"color": "#1A1A1A"
				//						}
				//					}, {
				//						"featureType": "airportlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "airportlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "scenicspotslabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "scenicspotslabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "medicallabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "medicallabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "medicallabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "scenicspotslabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "airportlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "entertainmentlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "entertainmentlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "entertainmentlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "estatelabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "estatelabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "estatelabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "businesstowerlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "businesstowerlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "businesstowerlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "companylabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "companylabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "companylabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "governmentlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "governmentlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "governmentlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "restaurantlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "restaurantlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "restaurantlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "hotellabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "hotellabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "hotellabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "shoppinglabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "shoppinglabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "shoppinglabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "lifeservicelabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "lifeservicelabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "lifeservicelabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "carservicelabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "carservicelabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "carservicelabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "financelabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "financelabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "financelabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "otherlabel",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "otherlabel",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "otherlabel",
				//						"elementType": "labels.icon",
				//						"stylers": {
				//							"visibility": "off"
				//						}
				//					}, {
				//						"featureType": "manmade",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "manmade",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "transportation",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "transportation",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "education",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "education",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "medical",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "medical",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}, {
				//						"featureType": "scenicspots",
				//						"elementType": "labels.text.fill",
				//						"stylers": {
				//							"color": "#2dc4bbff"
				//						}
				//					}, {
				//						"featureType": "scenicspots",
				//						"elementType": "labels.text.stroke",
				//						"stylers": {
				//							"color": "#ffff00"
				//						}
				//					}]
				//				})
			},

		}
	}
</script>

<style>
	body {
		margin: 0;
	}
	
	html {
		height: 100%;
		margin: 0;
		padding: 0;
	}
	
	.container {
		min-width: 1300px;
		/*min-height:100%;*/
		height: 100%;
		background: url(../assets/background.png) repeat;
		background-size: 5%;
	}
	
	el-container {
		margin: 0;
		padding: 0;
	}
	/*左*/
	
	.largeScreen .aside_Left {
		width: 13.1%!important;
		/*background: red!important;*/
		height: 100%;
		padding: 0 22px 0 44px;
	}
	
	.largeScreen .aside_top {
		/*background: green!important;*/
		position: relative;
		height: 22.2%;
		background-color: #191917;
		margin-top: 22px;
	}
	
	.largeScreen .lineBox {
		width: 100%;
		position: relative;
	}
	
	.largeScreen .dot_left {
		position: absolute;
		top: -1px;
		left: 0;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .link_top {
		height: 1px;
		border-top: solid #fff 1px;
	}
	
	.largeScreen .dot_right {
		position: absolute;
		top: -1px;
		right: 0%;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .allNumber {
		position: relative;
		font-size: 30px;
		font-weight: bold;
		display: inline-block;
		margin-top: 10px;
		color: #6DECFD;
		width: 100%;
	}
	
	.largeScreen .dot_left3 {
		position: absolute;
		top: -2px;
		left: 0px;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .link_top3 {
		position: absolute;
		top: 50%;
		right: 0%;
		width: 32%;
		height: 1px;
		border-top: solid #fff 1px;
		font-size: 12px;
	}
	
	.largeScreen .dot_right3 {
		position: absolute;
		top: -2px;
		right: 0px;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .allH {
		position: absolute;
		top: -23px;
		right: 0px;
	}
	
	.largeScreen .kwh {
		position: absolute;
		top: 3px;
		right: 0px;
	}
	
	.largeScreen .backgroundClass1 {
		margin: 2% 0 6% 0;
		height: 8.7%;
		background: linear-gradient(-45deg, #515150 25%, #999 0, #999 50%, #515150 0, #515150 75%, #999 0);
		background-size: 4px 4px;
	}
	
	.largeScreen .textTitle {
		position: relative;
		height: 14.5%;
	}
	
	.largeScreen .number {
		position: absolute;
		top: 6px;
		left: 0;
		color: #fff;
		font-size: 12px;
	}
	
	.largeScreen .time {
		position: absolute;
		top: 4px;
		right: -1px;
		color: #fff;
		font-size: 12px;
	}
	/*光循环向右淡出滑动*/
	
	@keyframes slider {
		0% {
			opacity: 0;
			left: 0;
		}
		13% {
			opacity: 1;
		}
		70% {
			opacity: .8;
		}
		100% {
			opacity: 0;
			left: 70%;
		}
	}
	
	.largeScreen .processBox {
		position: relative;
		height: 9.3%;
		background-color: #303030;
	}
	
	.largeScreen .processContent {
		height: 100%;
		background-color: #6DECFD;
		color: #6DECFD;
	}
	
	.largeScreen .dayEnergy,
	.largeScreen .monthEnergy,
	.largeScreen .allEnergySort {
		height: 21%;
		width: 100%;
	}
	
	.largeScreen .dayEnergy {
		position: relative;
		margin-top: 12%;
		/*background-color: powderblue;*/
	}
	/*横线的样式*/
	
	.largeScreen .lineBoxTop {
		width: 100%;
		position: absolute;
		top: 0;
		left: 0;
	}
	
	.largeScreen .lineBoxBottom {
		width: 100%;
		position: absolute;
		top: 22px;
		left: 0;
	}
	
	.largeScreen .titleLeft {
		position: absolute;
		top: 2%;
		left: 0;
		font-size: 12px;
		color: #fff;
	}
	
	.largeScreen .titleRight {
		position: absolute;
		top: 2%;
		right: 0;
		font-size: 12px;
		color: #fff;
	}
	
	.largeScreen .contentBox {
		padding-top: 13%;
		color: #fff;
		height: 84%;
		font-size: 12px;
	}
	
	.largeScreen .tab {
		height: 13%;
		width: 100%;
	}
	
	.largeScreen .lineContent {
		width: 100%;
		position: relative;
	}
	
	.largeScreen .lineContent .dot_left {
		position: absolute;
		top: -1px;
		left: 0;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .lineContent .link_top {
		position: absolute;
		top: 0;
		left: 0;
		width: 100%;
		height: 1px;
		border-top: solid #fff 1px;
	}
	
	.largeScreen .lineContent .dot_right {
		position: absolute;
		top: -1px;
		right: 0;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .leftEcharts {
		position: absolute;
		top: 13%;
		left: 0;
		width: 100%;
		/*width: 120%;*/
		height: 176px;
	}
	
	.largeScreen .monthEnergy {
		position: relative;
		margin-top: 16%;
		/*background-color: bisque;*/
	}
	
	.largeScreen .allEnergySort {
		position: relative;
		margin-top: 16%;
		height: 18%;
		/*background-color: rosybrown;*/
	}
	
	.largeScreen .allEcharts {
		position: absolute;
		top: 20%;
		left: 0;
		width: 117.5%;
		height: 96%;
		padding: 0;
		margin: 0;
	}
	/*中间*/
	
	.largeScreen .aside_center {
		padding: 0 4px;
		width: 65%!important;
	}
	
	.largeScreen .main {
		position: relative;
		margin-top: 2.9%;
		height: 69.5%;
		/*background-color: skyblue;*/
		padding: 0;
		color: #fff;
		font-size: 12px;
		font-weight: 400;
	}
	/*竖线*/
	
	.largeScreen .lineClass3 {
		position: absolute;
		top: 8px;
		left: 0;
		height: 96%;
		border-right: 1px solid #fff!important;
	}
	
	.largeScreen .lineClass2 {
		position: absolute;
		top: 8px;
		right: 0;
		height: 96%!important;
		border-right: 1px solid #fff;
	}
	
	.largeScreen .plussign_Top {
		font-size: 14px;
		position: absolute;
		top: -16px;
		left: -4px;
	}
	
	.largeScreen .plussign_Bottom {
		font-size: 14px;
		position: absolute;
		bottom: -16px;
		left: -4px;
	}
	
	.largeScreen .earchClass {
		width: 100%;
		height: 99%;
	}
	
	.largeScreen .lastClass {
		color: #fff;
		font-size: 12px;
		position: absolute;
		bottom: 1px;
		left: 44%;
	}
	
	.largeScreen .firstBox {
		position: absolute;
		top: 40%;
		left: 26%;
	}
	
	.largeScreen .secondBox {
		position: absolute;
		top: 44%;
		left: 20.6%;
	}
	
	.largeScreen .thirdBox {
		position: absolute;
		top: 50%;
		left: 26%;
	}
	
	.largeScreen .fourthBox {
		position: absolute;
		top: 60%;
		left: 23.4%;
	}
	
	.largeScreen .fivethBox {
		position: absolute;
		top: 70%;
		left: 24.8%;
	}
	
	.largeScreen .sixthBox {
		position: absolute;
		top: 45%;
		left: 70%;
	}
	
	.largeScreen .seventhBox {
		position: absolute;
		top: 54.5%;
		left: 70%;
	}
	
	.largeScreen .eightthBox {
		position: absolute;
		top: 52%;
		left: 69.8%;
	}
	
	.largeScreen .firstContent {
		position: relative;
		height: 100%;
	}
	
	.largeScreen .firsLine {
		position: absolute;
		top: 50%;
		left: 110%;
		width: 150%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .secondLine {
		position: absolute;
		top: 45%;
		left: -101%;
		width: 0.5px;
		height: 962%;
		background-color: #fff;
	}
	
	.largeScreen .thirdLine {
		position: absolute;
		top: 204%;
		left: -100%;
		width: 81%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .fourthLine {
		position: absolute;
		top: 363%;
		left: -100%;
		width: 81%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .fivethLine {
		position: absolute;
		top: 522%;
		left: -100%;
		width: 81%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .sixthLine {
		position: absolute;
		top: 681%;
		left: -100%;
		width: 81%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .seventhLine {
		position: absolute;
		top: 840%;
		left: -100%;
		width: 81%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .eightthLine {
		position: absolute;
		top: 1000%;
		left: -100%;
		width: 81%;
		height: 0.5px;
		background-color: #fff;
	}
	
	.largeScreen .secondText {
		position: absolute;
		top: 150%;
		left: 0;
		width: 120%;
	}
	
	.largeScreen .thirdText {
		position: absolute;
		top: 320%;
		left: 0;
		width: 180%;
	}
	
	.largeScreen .fourthText {
		position: absolute;
		top: 470%;
		left: 0;
		width: 120%;
	}
	
	.largeScreen .fivethText {
		position: absolute;
		top: 640%;
		left: 0;
		width: 180%;
	}
	
	.largeScreen .sixthText {
		position: absolute;
		top: 790%;
		left: 0;
		width: 120%;
	}
	
	.largeScreen .seventhText {
		position: absolute;
		top: 950%;
		left: 0;
		width: 120%;
	}
	
	.largeScreen .orangeLineLine {
		position: absolute;
		top: 50%;
		left: 110%;
		width: 150%;
		height: 0.5px;
		background-color: #EA1F1F;
	}
	
	.largeScreen .redLine {
		position: absolute;
		top: 50%;
		left: 110%;
		width: 150%;
		height: 0.5px;
		background-color: #FF734F;
	}
	
	.largeScreen .yellowLine {
		position: absolute;
		top: 50%;
		left: 110%;
		width: 150%;
		height: 0.5px;
		background-color: #F6D266;
	}
	
	.largeScreen .secondBox .firsLine {
		width: 80%;
	}
	
	.largeScreen .thirdBox .firsLine {
		width: 92%;
	}
	
	.largeScreen .fourthBox .firsLine {
		width: 60%;
	}
	
	.largeScreen .fivethBox .firsLine {
		width: 154%;
	}
	
	.largeScreen .sixthBox .firsLine {
		left: -160%;
		width: 140%;
	}
	
	.largeScreen .seventhBox .firsLine {
		left: -98%;
		width: 80%;
	}
	
	.largeScreen .eightthBox .firsLine {
		left: -81%;
		width: 70%;
	}
	
	.largeScreen .firsDot {
		position: absolute;
		top: 47%;
		right: -164%;
		display: inline-block;
		width: 3px;
		height: 3px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .secondBox .firsDot {
		right: -91%;
	}
	
	.largeScreen .thirdBox .firsDot {
		right: -104%;
	}
	
	.largeScreen .fourthBox .firsDot {
		right: -70%;
	}
	
	.largeScreen .sixthBox .firsDot {
		top: 44%;
		left: -160%;
	}
	
	.largeScreen .seventhBox .firsDot {
		top: 44%;
		left: -102%;
	}
	
	.largeScreen .eightthBox .firsDot {
		top: 44%;
		left: -81%;
	}
	
	@keyframes trans {
		0% {
			transform: rotate(0deg);
			-ms-transform: rotate(0deg);
			-webkit-transform: rotate(0deg);
		}
		100% {
			transform: rotate(-360deg);
			-ms-transform: rotate(-360deg);
			-webkit-transform: rotate(-360deg);
		}
	}
	
	.largeScreen .firstImg {
		position: absolute;
		top: -10%;
		right: -174%;
		display: inline-block;
		width: 25%;
		animation: trans 1.2s linear infinite;
	}
	
	.largeScreen .secondBox .firstImg {
		right: -98%;
		width: 16%;
	}
	
	.largeScreen .thirdBox .firstImg {
		right: -115%;
		width: 26%;
	}
	
	.largeScreen .fourthBox .firstImg {
		top: -15%;
		right: -79%;
		width: 21%;
	}
	
	.largeScreen .fivethBox .firstImg {
		width: 23%;
	}
	
	.largeScreen .sixthBox .firstImg {
		left: -175%;
		width: 35%;
	}
	
	.largeScreen .seventhBox .firstImg {
		left: -114%;
		width: 26%;
	}
	
	.largeScreen .eightthBox .firstImg {
		left: -90%;
		width: 18%;
	}
	
	@keyframes pulse {
		0% {
			opacity: 1;
		}
		/*50%{
			opacity: 0.5;
		}*/
		100% {
			opacity: 0.5;
		}
	}
	
	.largeScreen .fourthImg {
		position: absolute;
		top: -10%;
		right: -174%;
		display: inline-block;
		width: 24%;
		animation: pulse 0.2s linear infinite;
	}
	
	.largeScreen .header {
		padding: 0;
		margin: 0;
		height: 24.5%!important;
		/*background-color: orangered;*/
	}
	
	.largeScreen .header_top {
		width: 100%;
		height: 33%;
		background-color: #191917;
		padding-top: 22px;
		display: table;
		word-spacing: -1em;
		/*多个div的空隙*/
	}
	
	.largeScreen .allGatewayBackground1 {
		position: relative;
		display: inline-block;
		width: 50%;
		height: 64px;
		line-height: 64px;
		text-align: center;
		background: linear-gradient(-45deg, #4493A0 25%, #000 0, #000 50%, #4493A0 0, #4493A0 75%, #000 0);
		background-size: 8px 8px;
		color: #4493A0;
	}
	
	.largeScreen .allGatewayBackground2 {
		position: relative;
		display: inline-block;
		width: 50%;
		height: 64px;
		line-height: 64px;
		text-align: center;
		background: linear-gradient(-45deg, #275262 25%, #000 0, #000 50%, #275262 0, #275262 75%, #000 0);
		background-size: 8px 8px;
		color: #275262;
	}
	/*向左*/
	
	@keyframes sliderL {
		0% {
			opacity: 0;
			left: 0;
		}
		13% {
			opacity: 1;
		}
		70% {
			opacity: .8;
		}
		100% {
			opacity: 0;
			left: 20%;
		}
	}
	/*向右*/
	
	@keyframes sliderR {
		0% {
			opacity: 0;
			right: 0;
		}
		13% {
			opacity: 1;
		}
		70% {
			opacity: .8;
		}
		100% {
			opacity: 0;
			right: 20%;
		}
	}
	/*左边*/
	
	.largeScreen .leftContainer {
		position: absolute;
		top: 0;
		left: -6%;
		z-index: 100;
		width: 30%;
		animation: sliderL linear 1s infinite;
		-webkit-animation: sliderL linear 1s infinite;
	}
	/*右边*/
	
	.largeScreen .rightContainer {
		position: absolute;
		top: 0%;
		right: -6%;
		z-index: 100;
		width: 30%;
		animation: sliderR linear 1s infinite;
		-webkit-animation: sliderR linear 1s infinite;
	}
	
	.largeScreen .allGatewayBoxWhite {
		vertical-align: middle;
		display: inline-block;
		height: 36px;
		line-height: 36px;
		transform: skewX(-10deg);
		background-color: #fff;
	}
	
	.largeScreen .allGatewayContentWhite {
		display: inline-block;
		transform: skewX(10deg);
		font-weight: bold;
		font-size: 28px;
	}
	
	.largeScreen .gatewayText {
		font-weight: 400;
		font-size: 12px;
	}
	
	.largeScreen .allGatewayBoxOrange {
		vertical-align: middle;
		margin-left: -5px;
		display: inline-block;
		height: 36px;
		line-height: 36px;
		transform: skewX(-10deg);
		background-color: #FF734F;
	}
	
	.largeScreen .allGatewayContentOrange {
		display: inline-block;
		transform: skewX(10deg);
		font-weight: bold;
		font-size: 28px;
		/*color: rgba(255, 115, 79, 0);*/
		/*设置透明色*/
	}
	
	.largeScreen .header_bottom {
		height: 55.6%;
		/*background-color: pink;*/
		position: relative;
	}
	
	.largeScreen .rightLine {
		position: absolute;
		top: 12px;
		left: 50%;
		height: 68%;
		border-right: solid #fff 1px;
	}
	
	.largeScreen .dot_left2 {
		position: absolute;
		top: 0px;
		left: -1.5px;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .dot_right2 {
		position: absolute;
		top: 94%;
		left: -1.5px;
		display: inline-block;
		width: 4px;
		height: 4px;
		background-color: #fff;
		border-radius: 50%;
	}
	
	.largeScreen .header_content {
		display: inline-block;
		width: 49.5%;
		height: 100%;
		text-align: center;
	}
	
	.largeScreen .commonlyLine22 {
		margin-left: 10%;
		display: inline-block;
		width: 90%;
		margin-top: 6%;
		height: 3%;
		border-radius: 2px;
		background-image: linear-gradient(to right, #00ECFF, #1E201F)!important;
	}
	
	.largeScreen .commonlyLine33 {
		display: inline-block;
		width: 90%;
		margin-right: 10%;
		margin-top: 6%;
		height: 3%;
		border-radius: 2px;
		background-image: linear-gradient(to right, #1E201F, #00ECFF)!important;
	}
	
	.largeScreen .header_contentPL {
		font-size: 24px;
		font-weight: bold;
		color: #478EA4;
		margin-top: 20px;
		margin-bottom: 0px;
	}
	
	.largeScreen .header_contentPR {
		font-size: 24px;
		font-weight: bold;
		color: #FF734F;
		margin-top: 20px;
		margin-bottom: 0px;
	}
	
	.largeScreen .header_contentSpan {
		font-size: 12px;
		color: #fff;
		margin-top: 20px;
		margin-bottom: 0px;
	}
	/*右*/
	
	.largeScreen .aside_Right {
		width: 13.1%!important;
		/*background: red!important;*/
		height: 100%;
		padding: 0 44px 0 22px;
		position: relative;
	}
	
	.largeScreen .closeClass {
		position: absolute;
		top: 4px;
		right: 0px;
		color: #666;
		font-size: 26px;
	}
	
	.largeScreen .kwh2 {
		font-size: 17px;
	}
	
	.largeScreen .processBox2 {
		position: relative;
		width: 100%;
		height: 31.5%;
		background-color: #303030;
	}
	
	.largeScreen .processContent2 {
		height: 100%;
		background-color: #6DECFD;
		color: #6DECFD;
	}
	
	.largeScreen .projectArea {
		/*background-color: pink;*/
		position: relative;
		height: 26.5%;
		margin-top: 12%;
	}
	
	.largeScreen .backgroundClass2 {
		position: absolute;
		top: 2%;
		right: 0;
		height: 7.5%;
		width: 56%;
		background: linear-gradient(-45deg, #515150 25%, #999 0, #999 50%, #515150 0, #515150 75%, #999 0);
		background-size: 4px 4px;
	}
	
	.largeScreen .imgBox {
		position: absolute;
		top: 13%;
		left: 0;
		width: 100%;
		height: 87%;
	}
	
	.largeScreen .imgClass {
		width: 100%;
		height: 100%;
	}
	
	.largeScreen .backgroundClass3 {
		position: absolute;
		top: 2%;
		right: 0;
		height: 7.5%;
		width: 56%;
		background: linear-gradient(-45deg, #515150 25%, #FF734F 0, #FF734F 50%, #515150 0, #515150 75%, #FF734F 0);
		background-size: 4px 4px;
	}
	
	.largeScreen .pie-wrap {
		margin-top: 7%;
		display: inline-block;
		width: 100%;
		height: 100%;
	}
	
	.largeScreen .policeNumber {
		margin-top: 11%;
		position: relative;
		height: 25.5%;
		/*background-color: skyblue;*/
	}
	
	.largeScreen .typeBox {
		padding-top: 16%;
		height: 100%;
	}
	
	.largeScreen .urgentBox {
		position: relative;
		display: flex;
		height: 23%;
		margin-bottom: 3px;
		/*background-color:pink;*/
	}
	/*报警向左淡出滑动*/
	
	@keyframes sliderLeft {
		0% {
			opacity: 0;
			right: -12%;
		}
		13% {
			opacity: 1;
		}
		100% {
			opacity: .4;
			right: 10%;
		}
		/*from{
			opacity:0;
			right: -12%;
		}
		to{
			opacity:.4;
			right: 10%;
		}*/
	}
	
	.largeScreen .urgentCircle {
		margin: 19% 0 0 18%;
		position: relative;
		background-color: #fff;
		width: 61%;
		border-radius: 65%;
	}
	
	.largeScreen .urgentDian,
	.largeScreen .middleDian,
	.largeScreen .commonlyDian {
		position: absolute;
		top: 18%;
		left: 22%;
		color: #EA1F1F;
	}
	
	.largeScreen .middleDian {
		color: #FF734F!important;
	}
	
	.largeScreen .commonlyDian {
		color: #F6D266!important;
	}
	
	.largeScreen .urgentLeft,
	.largeScreen .middleLeft,
	.largeScreen .commonlyLeft {
		position: relative;
		flex: 3;
		margin-left: 4px;
		height: 98%;
		background-color: #EA1F1F;
		border-radius: 3px;
	}
	
	.largeScreen .middleLeft {
		background-color: #FF734F!important;
	}
	
	.largeScreen .commonlyLeft {
		background-color: #F6D266!important;
	}
	
	.largeScreen .a {
		width: 2px;
		height: 2px;
		position: absolute;
		top: -2px;
		left: -3px;
		border-left: 1px solid #fff;
		border-top: 1px solid #fff;
	}
	
	.largeScreen .b {
		width: 2px;
		height: 2px;
		position: absolute;
		top: -2px;
		right: -3px;
		border-right: 1px solid #fff;
		border-top: 1px solid #fff;
	}
	
	.largeScreen .c {
		width: 2px;
		height: 2px;
		position: absolute;
		bottom: -2px;
		left: -3px;
		border-bottom: 1px solid #fff;
		border-left: 1px solid #fff;
	}
	
	.largeScreen .d {
		width: 2px;
		height: 2px;
		position: absolute;
		bottom: -2px;
		right: -3px;
		border-right: 1px solid #fff;
		border-bottom: 1px solid #fff;
	}
	
	.largeScreen .urgentRight,
	.largeScreen .middleRight,
	.largeScreen .commonlyRight {
		padding-left: 10px;
		height: 100%;
		flex: 9;
		font-size: 12px;
		color: #EA1F1F;
	}
	
	.largeScreen .middleRight {
		color: #FF734F!important;
	}
	
	.largeScreen .commonlyRight {
		color: #F6D266!important;
	}
	
	.largeScreen .urgentNumber {
		font-size: 20px;
		font-weight: bold;
		height: 42%;
	}
	
	.largeScreen .urgentTitle {
		height: 30%;
	}
	
	.largeScreen .urgentLine,
	.largeScreen .middleLine,
	.largeScreen .commonlyLine {
		width: 100%;
		margin-top: 5%;
		height: 7%;
		background-image: linear-gradient(to right, #EA1F1F, #1E201F)!important;
	}
	
	.largeScreen .middleLine {
		background-image: linear-gradient(to right, #FF734F, #1E201F)!important;
	}
	
	.largeScreen .commonlyLine {
		background-image: linear-gradient(to right, #F6D266, #1E201F)!important;
	}
	
	.largeScreen .policeNumber .titleLeft {
		color: #FF734F!important;
	}
	
	.largeScreen .projectPolice {
		margin-top: 4%;
		position: relative;
		height: 8%;
		/*background-color: pink;*/
	}
	
	.largeScreen .projectPolice .titleLeft {
		color: #FF734F!important;
	}
	
	.largeScreen .backgroundClass4 {
		position: absolute;
		top: 6.5%;
		right: 0;
		height: 23.5%;
		width: 56%;
		background: linear-gradient(-45deg, #515150 25%, #FF734F 0, #FF734F 50%, #515150 0, #515150 75%, #FF734F 0);
		background-size: 4px 4px;
	}
	
	.largeScreen .ulbox {
		height: 100%;
		padding-top: 25%;
	}
	
	.largeScreen .ul {
		position: relative;
		height: 100%;
		color: #fff;
		font-size: 12px;
	}
	
	.largeScreen .warnRClass {
		position: absolute;
		top: -10%;
		left: 0;
		height: 70%;
	}
	
	.largeScreen .titleLeft2 {
		width: 70%;
		overflow: hidden;
		position: absolute;
		top: -17%;
		left: 0;
		font-size: 12px;
		color: #fff;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.largeScreen .titleRight2 {
		position: absolute;
		top: -17%;
		right: 0;
		font-size: 12px;
		color: #fff;
	}
	
	.largeScreen .processClass {
		position: relative;
		width: 100%;
		height: 6px;
		/*处理间隔*/
		display: table;
		word-spacing: -1em;
	}
	
	.largeScreen .processClassline {
		position: absolute;
		top: 46%;
		left: 0;
		height: 1px;
		width: 100%;
		background-color: #fff;
	}
	
	.largeScreen .urgentProcess {
		display: inline-block;
		height: 4px;
		background-color: #EA1F1F;
	}
	
	.largeScreen .middleProcess {
		display: inline-block;
		height: 4px;
		background-color: #FF734F;
	}
	
	.largeScreen .commonlyProcess {
		display: inline-block;
		height: 4px;
		background-color: #F6D266;
	}
	
	.largeScreen .processText {
		margin-top: -1.2%;
		width: 100%;
		height: 18px;
		line-height: 18px;
		background-color: #fff;
	}
	/*报警向右淡出滑动*/
	
	@keyframes sliderWarn {
		0% {
			opacity: 0;
			left: 0;
		}
		13% {
			opacity: .4;
		}
		70% {
			opacity: .2;
		}
		100% {
			opacity: 0;
			left: 57%;
		}
	}
	
	.largeScreen .processsAmClass {
		position: absolute;
		top: -10px;
		left: 0;
		width: 50%;
		height: 70%;
		opacity: .4;
		background: linear-gradient(to right, transparent, #00ECFF, #00ECFF);
		animation: sliderWarn linear 1s infinite;
		-webkit-animation: sliderWarn linear 1s infinite;
	}
	
	.largeScreen .urgentText {
		display: inline-block;
		width: 32%;
		color: #EA1F1F;
	}
	
	.largeScreen .middleText {
		display: inline-block;
		width: 32%;
		color: #FF734F;
	}
	
	.largeScreen .commonlyText {
		display: inline-block;
		width: 30%;
		color: #F6D266;
	}
	
	.largeScreen .marquee_wrap {
		width: 100%;
		position: absolute;
		top: 25%;
		left: 0;
		height: 70%;
		padding: 0;
		margin: 0;
		overflow: hidden;
	}
	
	.largeScreen .marquee_list {
		height: 100%;
		list-style: none;
		padding: 0;
		margin: 0;
	}
	
	.largeScreen .marquee_li {
		height: 40%;
	}
	
	.largeScreen .tabLeft {
		font-size: 12px;
		color: #fff;
		vertical-align: top;
		display: inline-block;
		width: 67%;
		overflow: hidden;
		text-overflow: ellipsis;
		white-space: nowrap;
	}
	
	.largeScreen .tabright {
		font-size: 11px;
		color: #fff;
		vertical-align: top;
		display: inline-block;
		text-align: right;
		width: 30%;
	}
	/*进度条去掉圆角*/
	
	.el-progress-bar__inner {
		border-radius: 0!important;
		background-color: #41939F;
	}
	
	.el-progress-bar__outer {
		border-radius: 0!important;
		background-color: #2B3F40;
	}
	/*去掉百度地图的图标*/
	
	.largeScreen .BMap_cpyCtrl {
		display: none;
	}
	
	.largeScreen .anchorBL {
		display: none;
	}
	
	.largeScreen .anchorTR {
		display: none;
	}
	/*窗口样式*/
	
	.largeScreen .BMap_pop .BMap_top {
		background: rgba(0, 0, 0, 0.01) !important;
		border: 0 !important;
	}
	
	.largeScreen .BMap_pop .BMap_center {
		border: 0 !important;
		background: rgba(0, 0, 0, 0.01) !important;
	}
	
	.largeScreen .BMap_pop .BMap_bottom {
		border: 0 !important;
		background: rgba(0, 0, 0, 0.01) !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(3) {
		background: transparent !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(3) div {
		border-radius: 3px;
		background: rgba(0, 0, 0, 0.01) !important;
		border: 0 !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(1) {
		border-radius: 3px 0 0 0;
		background: transparent !important;
		border: 0 !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(1) div {
		background: rgba(0, 0, 0, 0.01) !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(5) {
		border-radius: 0 0 0 3px;
		background: transparent !important;
		border: 0 !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(5) div {
		border-radius: 3px;
		background: rgba(0, 0, 0, 0.01) !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(7) {
		background: transparent !important;
	}
	
	.largeScreen .BMap_pop div:nth-child(7) div {
		border-radius: 3px;
		background: rgba(0, 0, 0, 0.01) !important;
	}
	
	.largeScreen img[src="http://api.map.baidu.com/images/iw_close1d3.gif"] {
		opacity: 0;
		content: url('http://vino.test.bidostar.cn/iw_close1d3.png')!important;
	}
	/*替换剪头*/
	
	.largeScreen img[src="http://api.map.baidu.com/images/iw3.png"] {
		opacity: 0;
		margin-top: -692px !important;
		filter: alpha(opacity=70);
		content: url('http://vino.test.bidostar.cn/iw3.png')!important;
	}
	/*光*/
	
	.largeScreen .linein {
		width: 45%;
		height: 6px;
		background-image: radial-gradient(#62F3FF 4%, transparent 80%);
		position: absolute;
		z-index: 10;
		left: 0;
		bottom: -2px;
		animation: slider linear 3s infinite;
		-webkit-animation: slider linear 3s infinite;
	}
	
	.largeScreen .lineout {
		position: absolute;
		z-index: 9;
		left: 14%;
		bottom: -6px;
		width: 70%;
		height: 18px;
		background-image: radial-gradient(#62F3FF 1%, transparent 70%);
	}
	
	.largeScreen .firstL,
	.largeScreen .secondL,
	.largeScreen .thirdL {
		font-size: 30px;
		font-weight: bolder;
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}
	
	.largeScreen .firstL {
		background-image: linear-gradient(to right, #D1FAFF, #F6FEFF);
	}
	
	.largeScreen .secondL {
		margin-left: -15px;
		background-image: linear-gradient(to right, #D2FAFF, #8DF2FE);
	}
	
	.largeScreen .thirdL {
		margin-left: -15px;
		background-image: linear-gradient(to right, #B8F7FF, #49EBFB);
	}
	/*右边*/
	
	.largeScreen .rightContainer2 {
		position: absolute;
		top: 0%;
		right: -100%;
		height: 100%;
		z-index: 100;
		width: 30%;
		animation: sliderR1 linear 1s infinite;
		-webkit-animation: sliderR1 linear 1s infinite;
	}
	/*向右*/
	
	@keyframes sliderR1 {
		0% {
			opacity: 0;
			right: -21%;
		}
		13% {
			opacity: 1;
		}
		70% {
			opacity: .8;
		}
		100% {
			opacity: 0;
			right: 6%;
		}
	}
	
	.largeScreen .firstL1,
	.largeScreen .secondL1,
	.largeScreen .thirdL1 {
		font-size: 28px;
		font-weight: bolder;
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}
	
	.largeScreen .firstL1 {
		background-image: linear-gradient(to right, #B11F1D, #811C1C);
		margin-left: -20px;
	}
	
	.largeScreen .secondL1 {
		margin-left: -20px;
		background-image: linear-gradient(to right, #811C1C, #53211F);
	}
	
	.largeScreen .thirdL1 {
		margin-left: -20px;
		background-image: linear-gradient(to right, #2E2724, #4C2621);
	}
	
	.largeScreen .firstL2,
	.largeScreen .secondL2,
	.largeScreen .thirdL2 {
		font-size: 28px;
		font-weight: bolder;
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}
	
	.largeScreen .firstL2 {
		background-image: linear-gradient(to right, #B62F1C, #572E1F);
		margin-left: -20px;
	}
	
	.largeScreen .secondL2 {
		margin-left: -20px;
		background-image: linear-gradient(to right, #893615, #572C22);
	}
	
	.largeScreen .thirdL2 {
		margin-left: -20px;
		background-image: linear-gradient(to right, #372923, #4D2922);
	}
	
	.largeScreen .firstL3,
	.largeScreen .secondL3,
	.largeScreen .thirdL3 {
		font-size: 28px;
		font-weight: bolder;
		background-clip: text;
		-webkit-background-clip: text;
		color: transparent;
	}
	
	.largeScreen .firstL3 {
		background-image: linear-gradient(to right, #A28532, #6B5B2A);
		margin-left: -20px;
	}
	
	.largeScreen .secondL3 {
		margin-left: -20px;
		background-image: linear-gradient(to right, #816C29, #443B29);
	}
	
	.largeScreen .thirdL3 {
		margin-left: -20px;
		background-image: linear-gradient(to right, #54472D, #353029);
	}
</style>


// WEBPACK FOOTER //
// src/components/LargeScreen.vue